



















import Vue from "vue"
import Viewer from "@/components/Viewer.vue";
import TitleBar from "@/components/TitleBar.vue";
import Sidebar from "@/components/Sidebar.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";

import {
  onMounted,
  watch,
  defineComponent,
} from "@vue/composition-api";

import { infoStore } from "@/store/infoStore";

export default defineComponent({
  components: {
    TitleBar,
    Nav,
    Viewer,
    Footer,
    Sidebar,
    Menu
  },
  setup(props, { root }) {
    watch(Vue.$setting, (val) => {
      console.log("pull")
      if(val.repository) infoStore.pull()
    })
    onMounted(() => {
      //console.log(root)
    });
  }
});
